<script>
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            source: String,
            course: Object,
            items: Array
        },
        data() {
            return {
                storageDate: null,
                date: moment(this.course.updated_at).add(48, 'hours'),
                now: Math.trunc(moment().valueOf() / 1000),
                promotions: this.items,
                form: new Form({
                    type: 'App\\CoursePromotion',
                    buyable: {},
                    promotion_id: ''
                })
            }
        },
        computed: {
            dateInMilliseconds() {
                return Math.trunc(this.date.valueOf() / 1000)
            },
            seconds() {
                return (this.dateInMilliseconds - this.now) % 60;
            },
            minutes() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
            },
            hours() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
            },
            days() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
            }
        },
        watch: {
            'form.promotion_id': {
                handler(val) {
                    let promotion = this.promotions.filter(i => i.id == val)
                    this.$set(this.form, 'buyable', _.head(promotion))
                    $('#promotion-error').hide();
                    $('#promotion-error-modal').hide();
                }
            }
        },
        mounted() {
            let courseDate = moment(this.course.updated_at).add(48, 'hours');
            let now = moment();
            while((courseDate.isBefore(now))) {
                courseDate = courseDate.add(48, 'hours');
            }
            this.$set(this, 'date', moment(courseDate));
            /*if ((courseDate - this.now) <= 0) {
                if (!window.localStorage.getItem(`date_${this.course.id}`)) {
                    window.localStorage.setItem(`date_${this.course.id}`, moment())
                }
                this.storageDate = window.localStorage.getItem(`date_${this.course.id}`)
                this.$set(this, 'date', moment(this.storageDate).add(this.countdown, this.interval))
            } else {
                this.$set(this, 'date', moment(this.course.updated_at).add(this.countdown, this.interval))
            }*/

            this.form.promotion_id = this.promotions[0].id

            let vm = this;
            window.setInterval(() => {
                /*if ((vm.dateInMilliseconds - vm.now) <= 0) {
                    window.localStorage.setItem(`date_${this.course.id}`, moment())
                    vm.storageDate = window.localStorage.getItem(`date_${this.course.id}`)
                    vm.$set(vm, 'date', moment(vm.storageDate).add(vm.countdown, vm.interval))
                }*/
                vm.now = Math.trunc(moment().valueOf() / 1000);
            }, 1000);
        },
        methods: {
            onClose() {
                this.form.reset()
            },
            getPromotionText(promotion) {
                let lessons = promotion.lessons > 1 ? 'lezioni' : 'lezione'
                let people = promotion.people > 1 ? 'persone' : 'persona'
                let lessonType = promotion.lesson_type == 'group' ? 'di gruppo' : 'individuale'
                let price = promotion.price;
                if (price % Math.trunc(price) == 0){
                    price = Math.trunc(promotion.price);
                } else {
                    price = promotion.price
                }

                /*let markup = `
                <span class="fw-700">${price}€</span>
                <span class="fw-400">${promotion.lessons} ${lessons} per ${promotion.people} ${people}</span>
                `;
                let string = $(".filter-option-inner-inner").html(markup);
                return string;*/
                return `${price}€ ${promotion.lessons} ${lessons} per ${promotion.people} ${people}`
            },
            addToCart() {
                this.form
                    .submit('post', 'addToCart')
                    .then((response) => {
                        window.alerts.success('Elemento aggiunto al carrello');
                        window.location = '/carts'
                    })
            },
            onSubmit() {
                if (!this.form.promotion_id){
                    $('#promotion-error').removeClass('d-none');
                    $('#promotion-error-modal').removeClass('d-none');
                }
                else {
                    this.form
                        .submit('post', this.source, {}, true)
                        .then(response => this.addToCart())

                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseBuyablePromotionForm.vue